import { checkIfRowContainsGeneratedCells } from "src/generator/_Buttons/AddCommentsButton/AddCommentsButton.utils";
import { type IRow } from "src/interfaces";

import { clearValues } from "./index";
/**
 * Clears the values of a row or its subrows, optionally copying previous values.
 *
 * @param row - The row object to be cleared.
 * @param copyPrevVal - (Optional) A number indicating whether to copy previous values.
 * @param isSingleRowInCat - (Optional) A boolean indicating if the row is the only one in its category.- Used for OLBs
 * @param forceFullClear - (Optional) A boolean to force complete clearing even if copyPrevVal is set.
 * @returns The cleared row object.
 */
export const clearRow = (
  row: IRow,
  copyPrevVal?: number,
  isSingleRowInCat?: boolean,
  forceFullClear?: boolean,
): IRow => {
  if (row.subrows) {
    const clearedObject = {
      subrows: row.subrows
        .filter((subrow: any) => !checkIfRowContainsGeneratedCells(subrow))
        .map((subrow: any) => {
          const cols = subrow.cols;
          return {
            cols: clearValues({ ...cols }, false, copyPrevVal, forceFullClear),
          };
        }),
    };
    return { subrows: clearedObject.subrows as any, isSingleRowInCat };
  } else {
    const clearedObject = clearValues(
      {
        ...row.cols,
      },
      false,
      copyPrevVal,
      forceFullClear,
    );
    return { cols: clearedObject as any, isSingleRowInCat };
  }
};
